import { Badge, Button, Space, Table } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  compareDates,
  compareStrings,
} from "../../../shared/table/sorterFunctions";

import { useNavigate } from "react-router-dom";
import {
  RENEWAL_STATUSES_MAP,
  RENEWAL_STATUS_DISPLAY,
  RENEWAL_STATUS_FILTERS,
} from "../../../shared/constants";
import {
  getDateFilterProps,
  getTextFilterProps,
} from "../../../shared/table/filterFunctions";
import { setIsDownloading } from "../../../store/downloads/downloadsSlice";

const RenewalsSearchTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state.renewalsSearch.data);
  const isLoading = useSelector((state) => state.renewalsSearch.isLoading);

  useEffect(() => {
    dispatch(setIsDownloading(false));
  }, []);

  const columns = [
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      width: 100,
      render: (status) => (
        <Badge
          status={RENEWAL_STATUSES_MAP[status] || "error"}
          text={RENEWAL_STATUS_DISPLAY[status] || status}
        />
      ),
      sorter: (a, b) => compareStrings(a, b, "status"),
      filters: RENEWAL_STATUS_FILTERS,
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Insured Name",
      dataIndex: "main_owner_name",
      key: "main_owner_name",
      width: 125,
      sorter: (a, b) => compareStrings(a, b, "main_owner_name"),
      ...getTextFilterProps("main_owner_name", "Insured Name"),
    },
    {
      title: "Customer Code",
      dataIndex: "customer_code",
      key: "customer_code",
      width: 110,
      sorter: (a, b) => compareStrings(a, b, "customer_code"),
      ...getTextFilterProps("customer_code", "Customer Code"),
    },
    {
      title: "Aircraft",
      key: "aircraft",
      dataIndex: "aircraft",
      width: 160,
      sorter: (a, b) => compareStrings(a, b, "aircraft"),
      ...getTextFilterProps("aircraft", "Aircraft"),
    },
    {
      title: "Expiry Date",
      key: "previous_policy_expiry_date",
      dataIndex: "previous_policy_expiry_date",
      width: 100,
      render: (data) => dayjs(data).format("YYYY-MM-DD"),
      sorter: (a, b) => compareDates(a, b, "previous_policy_expiry_date"),
      ...getDateFilterProps("previous_policy_expiry_date"),
    },
    {
      key: "action",
      width: 50,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            type="link"
            onClick={() => {
              navigate(`/renewals/view/${record.id}`);
            }}
          >
            View
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      size="small"
      scroll={{ x: 670, y: 500 }}
      bordered
      sticky
      pagination={{ defaultPageSize: 50, pageSizeOptions: [10, 20, 50, 100] }}
      loading={isLoading}
    />
  );
};

export default RenewalsSearchTable;
